// VinnyIcon.js
import React from 'react';

import vinnyBotIcon from '../../../assets/vinny-bot.svg';

const VinnyIcon = ({ className, style, ...rest }) => {
  return (
    <img
      src={vinnyBotIcon}
      alt="Vinny assistant"
      className={`vinny-icon ${className || ''}`}
      style={{ width: '44px', height: '44px', objectFit: 'contain', filter: 'drop-shadow(0px 0px 2px rgba(255,255,255,0.8))', ...style }}
      {...rest}
    />
  );
};

export default VinnyIcon;
